export const getBrandCountries = () => {
    let countries;
    try {
        countries = JSON.parse(document.body.dataset.countries);
    }
    catch {
        // eslint-disable-next-line no-console
        console.error("Couldn't get brand countries");
        countries = [];
    }
    return countries;
};
export const getDefaultCountry = () => {
    let defaultCountry;
    try {
        defaultCountry = JSON.parse(document.body.dataset.defaultCountry);
    }
    catch {
        // eslint-disable-next-line no-console
        console.error("Couldn't get default country data");
    }
    return defaultCountry;
};
export const getMapCountrySite = () => {
    let mapCountrySite;
    try {
        mapCountrySite = JSON.parse(document.body.dataset.mapCountrySite);
    }
    catch {
        // eslint-disable-next-line no-console
        console.error("Couldn't get default country site map");
        mapCountrySite = {};
    }
    return mapCountrySite;
};
export const getUserAgentCountry = () => {
    const userAgent = navigator.userAgent;
    const parts = userAgent.split(' ');
    let code;
    let currency;
    parts.forEach((part) => {
        if (part.startsWith('iso2Country')) {
            code = part.split('/')[1];
        }
        if (part.startsWith('isoCurrencyGlobalE')) {
            currency = part.split('/')[1];
        }
    });
    return code && currency
        ? {
            code,
            currency,
        }
        : undefined;
};
const FORCED_COUNTRY_NAMES = {
    HK: 'Hong Kong SAR',
    MO: 'Macau SAR',
    TW: 'Taiwan Area',
};
export const getCountryName = async (countryCode, locale = document.documentElement.lang) => {
    // for some countries we force the displayed name
    const forcedName = FORCED_COUNTRY_NAMES[countryCode];
    if (forcedName)
        return forcedName;
    let countryName;
    try {
        countryName = new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode);
    }
    catch {
        countryName = countryCode;
    }
    return countryName;
};
export const getLanguageName = async (countryCode, locale = document.documentElement.lang) => {
    let languageName;
    try {
        languageName = new Intl.DisplayNames([locale], { type: 'language' }).of(countryCode);
    }
    catch {
        languageName = countryCode;
    }
    return languageName.charAt(0).toUpperCase() + languageName.slice(1);
};
// List from https://www.sezane.com/choose-country-region/
export const GLOBALE_COUNTRIES_CURRENCIES = [
    { country: 'AD', currency: 'EUR' },
    { country: 'AE', currency: 'AED' },
    { country: 'AR', currency: 'ARS' },
    { country: 'AT', currency: 'EUR' },
    { country: 'AU', currency: 'AUD' },
    { country: 'BA', currency: 'BAM' },
    { country: 'BE', currency: 'EUR' },
    { country: 'BG', currency: 'BGN' },
    { country: 'BH', currency: 'BHD' },
    { country: 'BL', currency: 'EUR' },
    { country: 'BR', currency: 'BRL' },
    { country: 'BY', currency: 'BYN' },
    { country: 'CA', currency: 'CAD' },
    { country: 'CH', currency: 'CHF' },
    { country: 'CI', currency: 'XOF' },
    { country: 'CL', currency: 'CLP' },
    { country: 'CN', currency: 'CNY' },
    { country: 'CO', currency: 'COP' },
    { country: 'CY', currency: 'EUR' },
    { country: 'CZ', currency: 'CZK' },
    { country: 'DE', currency: 'EUR' },
    { country: 'DK', currency: 'DKK' },
    { country: 'EE', currency: 'EUR' },
    { country: 'ES', currency: 'EUR' },
    { country: 'FI', currency: 'EUR' },
    { country: 'FR', currency: 'EUR' },
    { country: 'GB', currency: 'GBP' },
    { country: 'GE', currency: 'GEL' },
    { country: 'GF', currency: 'EUR' },
    { country: 'GG', currency: 'GBP' },
    { country: 'GP', currency: 'EUR' },
    { country: 'GR', currency: 'EUR' },
    { country: 'HK', currency: 'HKD' },
    { country: 'HR', currency: 'HRK' },
    { country: 'HU', currency: 'HUF' },
    { country: 'IC', currency: 'EUR' },
    { country: 'ID', currency: 'IDR' },
    { country: 'IE', currency: 'EUR' },
    { country: 'IL', currency: 'ILS' },
    { country: 'IM', currency: 'GBP' },
    { country: 'IN', currency: 'INR' },
    { country: 'IS', currency: 'ISK' },
    { country: 'IT', currency: 'EUR' },
    { country: 'JE', currency: 'GBP' },
    { country: 'JP', currency: 'JPY' },
    { country: 'KR', currency: 'KRW' },
    { country: 'KW', currency: 'KWD' },
    { country: 'LB', currency: 'LBP' },
    { country: 'LI', currency: 'CHF' },
    { country: 'LT', currency: 'EUR' },
    { country: 'LU', currency: 'EUR' },
    { country: 'LV', currency: 'EUR' },
    { country: 'MA', currency: 'MAD' },
    { country: 'MC', currency: 'EUR' },
    { country: 'MF', currency: 'EUR' },
    { country: 'MO', currency: 'MOP' },
    { country: 'MQ', currency: 'EUR' },
    { country: 'MT', currency: 'EUR' },
    { country: 'MU', currency: 'MUR' },
    { country: 'MX', currency: 'MXN' },
    { country: 'MY', currency: 'MYR' },
    { country: 'NC', currency: 'EUR' },
    { country: 'NG', currency: 'NGN' },
    { country: 'NL', currency: 'EUR' },
    { country: 'NO', currency: 'NOK' },
    { country: 'NZ', currency: 'NZD' },
    { country: 'OM', currency: 'OMR' },
    { country: 'PA', currency: 'PAB' },
    { country: 'PE', currency: 'PEN' },
    { country: 'PF', currency: 'EUR' },
    { country: 'PH', currency: 'PHP' },
    { country: 'PL', currency: 'PLN' },
    { country: 'PT', currency: 'EUR' },
    { country: 'QA', currency: 'QAR' },
    { country: 'RE', currency: 'EUR' },
    { country: 'RO', currency: 'RON' },
    { country: 'RS', currency: 'RSD' },
    { country: 'RU', currency: 'RUB' },
    { country: 'SA', currency: 'SAR' },
    { country: 'SE', currency: 'SEK' },
    { country: 'SG', currency: 'SGD' },
    { country: 'SI', currency: 'EUR' },
    { country: 'SK', currency: 'EUR' },
    { country: 'SN', currency: 'XOF' },
    { country: 'TH', currency: 'THB' },
    { country: 'TN', currency: 'TND' },
    { country: 'TR', currency: 'TRY' },
    { country: 'TW', currency: 'TWD' },
    { country: 'UA', currency: 'UAH' },
    { country: 'US', currency: 'USD' },
    { country: 'US', currency: 'USD' },
    { country: 'UY', currency: 'UYU' },
    { country: 'VC', currency: 'XCD' },
    { country: 'VN', currency: 'VND' },
    { country: 'WF', currency: 'EUR' },
    { country: 'YT', currency: 'EUR' },
    { country: 'ZA', currency: 'ZAR' },
];
